module.exports = __webpack_public_path__ + "img/ufeel-logo.6e0de4be.png";